import request from "@/utils/request";

/**
 * 获取项目列表
 * @param param
 */
export function fetchList(companyId) {
  return request({
    url: "/api/rep/model/list/" + companyId,
    method: "post"
  });
}

/**
 * 获取项目列表
 * @param param
 */
export function findUserPostMatch(query) {
  return request({
    url: `/api/rep/model/post/fenc/${query.projectId}/${query.userId}`,
    method: "post",
    data: query.postIds
  });
}

/**
 * 获取项目列表
 * @param param
 */
export function getPostImage(projectId, userId, postId) {
  return request({
    url: `/api/rep/model/post/image/${projectId}/${userId}/${postId}`,
    method: "post",
  });
}

/**
 * 新增公告
 * @param param
 */
export function save(query) {
  return request({
    url: "/api/rep/model/save",
    method: "post",
    data: query
  });
}

/**
 * 修改公告
 * @param param
 */
export function update(query) {
  return request({
    url: "/api/rep/model/update",
    method: "post",
    data: query
  });
}

/**
 * 获取公告
 * @param param
 */
export function get(id) {
  return request({
    url: "/api/rep/model/get/" + id,
    method: "get"
  });
}

/**
 * 删除公告
 * @param param
 */
export function remove(id) {
  return request({
    url: "/api/rep/model/delete/" + id,
    method: "post"
  });
}


